/**
 * Admin Layout Component
 * Provides the main layout for the admin panel
 */

import { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './admin.css';

interface AdminLayoutProps {
  children: ReactNode;
  onBack: () => void;
  activeTab: 'dashboard' | 'users' | 'simulation';
  onTabChange: (tab: 'dashboard' | 'users' | 'simulation') => void;
}

export function AdminLayout({ children, onBack, activeTab, onTabChange }: AdminLayoutProps) {
  const { user, logout } = useAuth();

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="admin-header-left">
          <button className="admin-back-btn" onClick={onBack}>
            ← Volver al juego
          </button>
          <h1>GENESIS Admin</h1>
        </div>
        <div className="admin-header-right">
          {user && (
            <div className="admin-user">
              {user.image && <img src={user.image} alt="" className="admin-avatar" />}
              <span>{user.name || user.email}</span>
            </div>
          )}
          <button className="admin-logout-btn" onClick={logout}>
            Salir
          </button>
        </div>
      </header>

      <nav className="admin-nav">
        <button
          className={`admin-nav-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => onTabChange('dashboard')}
        >
          Panel
        </button>
        <button
          className={`admin-nav-btn ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => onTabChange('users')}
        >
          Usuarios
        </button>
        <button
          className={`admin-nav-btn ${activeTab === 'simulation' ? 'active' : ''}`}
          onClick={() => onTabChange('simulation')}
        >
          Simulación
        </button>
      </nav>

      <main className="admin-main">{children}</main>
    </div>
  );
}
